module.exports = __webpack_public_path__ + "img/xp_coupon_500.02ee9e52.png";